import { render, staticRenderFns } from "./AntispasmodicList.vue?vue&type=template&id=1e8cf3c2&"
import script from "./AntispasmodicList.vue?vue&type=script&lang=js&"
export * from "./AntispasmodicList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports